import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    table: {
      '& .MuiToolbar-root': {
        backgroundColor: theme.palette.background.alternative,
        '& .MuiSvgIcon-root': {
          color: theme.palette.text.primary,
        },
      },
      '& .MuiTableCell-root': {
        backgroundColor: theme.palette.background.alternative,
      },
      '& .MuiTooltip-root': {
        backgroundColor: theme.palette.background.alternative,
      },
    },
  });

export default styles;
